export const TAXABLE_TYPE_LABEL_OVERRIDE = {
  travel_stipend: 'Housing stipend',
  meal_stipend: 'M&IE stipend',
  parking_reimbursement: 'Parking',
  bonus: 'Boost',
  incentive_bonus: 'Limited-time incentive',
};
